import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable, type Functions } from "firebase/functions";
import { env } from "../env";

let cachedFunctions: Functions | null = null;

export function getFns(): Functions {
  if (cachedFunctions) return cachedFunctions;
  const app = initializeApp({
    apiKey: env.firebase.apiKey,
    authDomain: env.firebase.authDomain,
    projectId: env.firebase.projectId,
    appId: env.firebase.appId,
    storageBucket: env.firebase.storageBucket,
  });
  cachedFunctions = getFunctions(app, env.functionsRegion);
  return cachedFunctions;
}

/** Long enough to absorb a Cloud Functions gen2 cold start (~30–60s). */
const CALLABLE_TIMEOUT_MS = 120_000;

export function callable<TReq, TResp>(name: string) {
  return httpsCallable<TReq, TResp>(getFns(), name, {
    timeout: CALLABLE_TIMEOUT_MS,
  });
}
